import * as React from 'react';

import { Heading } from '../../../../../../../../components';
import {
  ButtonCancel,
  ButtonContainer,
  ButtonRequest,
  CommonBlock,
  DataInfo
} from './styled';

interface ConfirmationModalProps {
  phone: string;
  campusName: string;
  handleClick: () => void;
  handleClose: () => void;
}
const ConfirmationModal: React.FC<ConfirmationModalProps> = (props) => {
  const { phone, campusName, handleClick, handleClose } = props;
  return (
    <CommonBlock>
      <div>
        <Heading
          text="¿Los datos de la solicitud son correctos?"
          level={2}
          color="#161D1F"
          size={20}
          lineHeight={32}
          fontWeight="900"
          className=""
          align="center"
          width="100%"
        />
        <DataInfo>
          <p>Verifica los datos ingresados:</p>
          <ul>
            <li>
              <span>Contacto: {phone}</span>
            </li>
            <li>
              <span>Campus de recojo: {campusName}</span>
            </li>
          </ul>
        </DataInfo>
        <ButtonContainer>
          <ButtonRequest onClick={() => handleClick()}>
            <p>Sí, enviar</p>
          </ButtonRequest>
          <ButtonCancel onClick={() => handleClose()}>
            <p>Cancelar</p>
          </ButtonCancel>
        </ButtonContainer>
      </div>
    </CommonBlock>
  );
};

export default ConfirmationModal;
